const _ = require('underscore');

const checkCategoryEligibility = (type = '', categories = []) => {
  const categoryIds = categories.map(el => el.id);
  const { eligibleCategoryFor2RowSize } = require('./Constant');
  const eligibleCategoryIDs = eligibleCategoryFor2RowSize[type];
  return !!eligibleCategoryIDs && categoryIds.some(id => eligibleCategoryIDs.includes(id));
};

const getSwatchesColors = (swatches) => {
  const colors = swatches
    .map(swatch => swatch.availableColors || [])
    .reduce((acc, colorArray) => acc.concat(colorArray), [])
    .filter((val, index, arr) => arr.indexOf(val) === index);
  return colors;
};


const getOriginalIndex = (size, index, status) => {
  const copyRaw = Object.assign({}, size);
  copyRaw.originalIndex = index;
  copyRaw.belongTo = status;
  return copyRaw;
};


const getDeviceType = (options, device) => {
  if (options.context) {
    const { deviceType } = options.context;
    return deviceType === device;
  }
  return false;
};

const getSizesByType = (type, splittedSizes, SizesType) => {
  const { values, some } = _;
  const withType = t => t === type;

  if (some(values(SizesType), withType)) {
    switch (type) {
      case SizesType.numericSize:
        return splittedSizes.numericSizes;
      case SizesType.letterSize:
        return splittedSizes.letterSizes;
      default:
        return null;
    }
  }
  return null;
};

module.exports = {
  checkCategoryEligibility,
  getSwatchesColors,
  getOriginalIndex,
  getDeviceType,
  getSizesByType,
};



// WEBPACK FOOTER //
// /Users/m802941/WebstormProjects/2020/campaigns/shop-the-look-pdp/node_modules/@page/digital-product-ui-mcom/src/js/util/productModelHelper/ProductModelParserUtil.js